import loadable from "@loadable/component";
import { Carousel, CarouselProps } from "@tvg/fuse/carousel";
import useSlotConfig from "client/context/SlotConfig";
import React from "react";

export interface QuickFilterCarouselProps extends Partial<CarouselProps> {}

const QuickFilter = loadable(() => import(/* webpackChunkName: "QuickFilter" */ "./QuickFilter"));

export const QuickFilterCarousel: React.FC<QuickFilterCarouselProps> = () => {
  const { heroBanners, quickFilters } = useSlotConfig();

  if (!quickFilters?.slides?.length || heroBanners?.length) return null;
  return (
    <Carousel
      columnGapSize={{ xxs: 3, m: 4, l: 7, xl: 10 }}
      dataTestId="content-quick-filter-carousel"
      touchPeek
      lCardsPerPage={5}
      mCardsPerPage={4}
      xxsCardsPerPage={3}
      key={quickFilters._meta.deliveryId}
      componentId="content-quick-filter-carousel"
    >
      {quickFilters.slides.map(({ _meta, ...config }, idx) => (
        <QuickFilter key={_meta.deliveryId} {...config} position={idx} />
      ))}
    </Carousel>
  );
};
